// 喜马拉雅音频播放器
<template>
  <div class="view22Wrapper shadowRadius cardMinHeight" ref="wrapper">
    <div v-if="isAudioLoading" class="loading">
      <img src="~@/assets/img/loading1.gif" alt="" />
    </div>
    <div class="playerWrapper">
      <div class="audioInfo">
        <div class="cover">
          <img
            :src="audioList[audioCurrentIndex].cover_url_small"
            alt="频道封面"
          />
        </div>
        <div class="content">
          <my-marquee
            v-if="audioList[audioCurrentIndex].track_title.length > 9"
            :text="audioList[audioCurrentIndex].track_title"
            styleType="title"
          ></my-marquee>
          <div class="name" v-else>
            {{ audioList[audioCurrentIndex].track_title }}
          </div>
          <div class="source">内容来源：喜马拉雅</div>
          <my-marquee
            :text="audioList[audioCurrentIndex].track_intro"
            styleType="normal"
          ></my-marquee>
        </div>
      </div>
      <div
        v-if="!isPC"
        class="slider"
        @touchstart="handleTouchStart"
        ref="track"
      >
        <div class="slider-track"></div>
        <div class="slider-fill" :style="{ width: `${progress}%` }"></div>
        <div class="slider-thumb" :style="{ left: `${progress}%` }"></div>
      </div>
      <div v-else class="slider" @mousedown="handleMouseDown" ref="pcTrack">
        <div class="slider-track"></div>
        <div class="slider-fill" :style="{ width: `${progress}%` }"></div>
        <div class="slider-thumb" :style="{ left: `${progress}%` }"></div>
      </div>
      <div class="timeInfo">
        <div class="currentTime">
          {{ formatTime(audioCurrentTime) }}
        </div>
        <div class="duration">
          {{ formatTime(duration) }}
        </div>
      </div>
      <div class="menu">
        <div class="last" @click="handleLastAudio">
          <img src="~@/assets/img/lastAudio.png" alt="上一首" />
        </div>
        <div class="play" @click="handlePlay">
          <div v-if="isPlay">
            <img src="~@/assets/img/pauseAudio.png" alt="暂停" />
          </div>
          <div v-else>
            <img src="~@/assets/img/playAudio.png" alt="开始" />
          </div>
        </div>
        <div class="next" @click="handleNextAudio">
          <img src="~@/assets/img/nextAudio.png" alt="下一首" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  formatAudioTime,
  ximalayaDetailTemplate,
  debounce,
} from "@/utils/utils";
import MyMarquee from "@/components/Use/my-marquee";
import { XMplayer } from "@xmly-fem/web-jssdk";
import COVERAPP from "../../utils/COVERAPP";

export default {
  name: "View22",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    tips: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      progress: 0,
      isPlay: false,
      isMove: false, //这里用一个变量判断用户是否拖动进度条,
      timeout: null,
      timer: null,
      playList: [],
    };
  },
  components: { MyMarquee },
  computed: {
    ...mapState([
      "isPC",
      "questionTips",
      "device",
      "isApp",
      "AutoplayIng",
      "AutoplayPlayer",
      "isToSpeakIng",
    ]),
    ...mapState("audio", [
      "audioCurrentIndex",
      "audioList",
      "audioCurrentTime",
      "duration",
      "xPlayer",
      "isAudioLoading",
    ]),
  },
  created() {
    // console.log("每次刷新都会走这里不呢？", this.AutoplayIng);
    if (this.list !== this.audioList) {
      this.setAudioList(this.list);
      let playList = [];
      this.list.forEach((item) => {
        playList.push(item.id);
      });
      // 若当前未播放喜马拉雅音频,随机播放音频
      if (this.audioCurrentIndex === -1) {
        this.setAudioCurrentIndex(0);
      }

      this.playList = playList;
      this.setInitListData(playList);
    }
  },
  mounted() {
    // console.log("view222页面刷新没有走这里嘛？？？？？？");
    if (this.AutoplayIng) {
      // 正在播放语音旁白，就暂时不播放语音，用监听AutoplayIng属性的方式来设置播放
      this.isPlay = false;
    } else {
      this.setInitPlayData();
    }
  },
  watch: {
    AutoplayIng(value) {
      if (!value) {
        // this.setInitListData(this.playList)
        this.setInitPlayData();
      }
    },
    isToSpeakIng(val) {
      // 路由时，停止播放
      if (!this.AutoplayIng) {
        if (val) {
          this.isPlay = false;
          this.xPlayer.pause();
        } else {
          this.isPlay = true;
          this.xPlayer.play();
        }
      }
    },
  },
  destroyed() {
    this.isPlay = true;
    this.xPlayer.pause();
    this.setAudioLoading(false);
    clearInterval(this.timer);
    this.xPlayer.off("timeupdate");
  },

  methods: {
    ...mapMutations("audio", [
      "setAudioCurrentIndex",
      "setAudioCurrentTime",
      "setAudioList",
      "setDuration",
      "setXPlayer",
      "setAudioLoading",
      "setPause",
    ]),
    ...mapMutations(["contactDisData"]),
    setInitListData(playList) {
      // console.log("设置播放列表",playList,this.audioCurrentIndex)
      this.setXPlayer(new XMplayer({ playlist: playList }));
    },
    setInitPlayData() {
      // console.log("setInitPlayData===this.audioCurrentIndex===",this.audioCurrentIndex,this.audioList)
      // this.setAudioLoading(true);
      // 兼容IOS端不能自动播放的情况，故使用喜马拉雅给的时长
      this.setDuration(this.audioList[this.audioCurrentIndex].duration);
      this.timeUpdate();
      this.reset();
      if (this.AutoplayIng) {
        this.xPlayer.pause();
        this.isPlay = true;
      } else {
        this.handlePlay();
      }
    },

    timeUpdate() {
      this.xPlayer.on("timeupdate", (position, sound) => {
        if (this.xPlayer.getDuration() !== this.duration) {
          this.setDuration(this.xPlayer.getDuration());
        }
        if (!this.isMove) {
          this.setAudioCurrentTime(
            position > this.duration ? this.duration : position
          );
          if (position === 0) {
            this.progress = 0;
          } else if (position >= this.xPlayer.getDuration()) {
            this.progress = 100;
          } else {
            this.progress = (position / this.duration) * 100;
          }
          //部分音频有喜马拉雅的音频贴片,如果有广告获取的音乐时长将为0
          if (this.progress === 100) {
            this.handleNextAudio();
          }
        }
      });
    },
    handleLastAudio() {
      //  console.log("点击last====");
      this.debounce(() => {
        this.xPlayer.prev();

        this.reset();
      }, 500);
    },
    handlePlay() {
      if (!this.xPlayer.getDuration()) {
        this.isPlay
          ? this.xPlayer.pause()
          : this.xPlayer.playByIndex(this.audioCurrentIndex);
      } else {
        this.isPlay ? this.xPlayer.pause() : this.xPlayer.play();
      }
      this.isPlay = !this.isPlay;
    },
    handleNextAudio() {
      this.debounce(() => {
        this.xPlayer.next();

        this.reset();
      }, 500);
    },
    handleMouseDown(e) {
      if (!this.xPlayer.getDuration()) {
        this.xPlayer.playByIndex(this.audioCurrentIndex);
      } else {
        this.xPlayer.play();
      }
      this.isPlay = true;
      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", this.handleMouseEnd);
    },
    handleMouseMove(e) {
      this.isMove = true;
      if (this.device !== "ios") {
        this.xPlayer.pause();
      }
      this.setPcMoveValue(e);
    },
    handleMouseEnd(e) {
      this.isMove = false;
      if (!this.xPlayer.getDuration()) {
        this.xPlayer.playByIndex(this.audioCurrentIndex);
      } else {
        this.xPlayer.play();
      }
      this.setPcValue(e);
      document.removeEventListener("mousemove", this.handleMouseMove);
      document.removeEventListener("mouseup", this.handleMouseEnd);
    },
    handleTouchStart(e) {
      if (!this.xPlayer.getDuration()) {
        this.xPlayer.playByIndex(this.audioCurrentIndex);
      } else {
        this.xPlayer.play();
      }
      this.isPlay = true;
      document.addEventListener("touchmove", this.handleTouchMove);
      document.addEventListener("touchup", this.handleTouchEnd);
      document.addEventListener("touchend", this.handleTouchEnd);
      document.addEventListener("touchcancel", this.handleTouchEnd);
    },
    handleTouchMove(e) {
      // this.xPlayer.pause() 这里不直接暂停时为了兼容IOS端
      if (this.device !== "ios") {
        this.xPlayer.pause();
      }
      this.isMove = true;
      this.setMoveValue(e.changedTouches[0]);
    },
    handleTouchEnd(e) {
      this.isMove = false;
      this.setMoveValue(e.changedTouches[0]);
      this.setValue(e.changedTouches[0]);
      document.removeEventListener("touchmove", this.handleTouchMove);
      document.removeEventListener("touchup", this.handleTouchEnd);
      document.removeEventListener("touchend", this.handleTouchEnd);
      document.removeEventListener("touchcancel", this.handleTouchEnd);
    },
    setValue(e) {
      let currentTime =
        ((e.clientX - this.$refs.track.getBoundingClientRect().left) /
          this.$refs.track.clientWidth) *
        this.duration;
      currentTime = currentTime < this.duration ? currentTime : this.duration;
      this.setAudioCurrentTime(currentTime);
      this.xPlayer.seek(currentTime);
      if (!this.xPlayer.getDuration()) {
        this.xPlayer.playByIndex(this.audioCurrentIndex);
      } else {
        this.xPlayer.play();
      }
    },
    setMoveValue(e) {
      let progress =
        ((e.clientX - this.$refs.track.getBoundingClientRect().left) /
          this.$refs.track.clientWidth) *
        100;
      this.progress = progress > 100 ? 100 : progress < 0 ? 0 : progress;
      this.setAudioCurrentTime((this.progress * this.duration) / 100);
    },
    setPcValue(e) {
      let currentTime =
        ((e.clientX - this.$refs.pcTrack.getBoundingClientRect().left) /
          this.$refs.pcTrack.clientWidth) *
        this.duration;
      currentTime = currentTime < this.duration ? currentTime : this.duration;
      this.setAudioCurrentTime(currentTime);
      this.xPlayer.seek(currentTime);
    },
    setPcMoveValue(e) {
      let progress =
        ((e.clientX - this.$refs.pcTrack.getBoundingClientRect().left) /
          this.$refs.pcTrack.clientWidth) *
        100;
      this.progress = progress > 100 ? 100 : progress < 0 ? 0 : progress;
      this.setAudioCurrentTime((this.progress * this.duration) / 100);
    },
    formatTime(time) {
      return formatAudioTime(time);
    },

    reset() {
      this.timer = setInterval(() => {
        this.setAudioLoading(true);
        // console.log("reset=====")
        let duration = this.xPlayer.getDuration();
        // console.log(
        //   "this.xPlayer===duration",
        //   duration,
        //   this.audioCurrentTime,
        //   this.xPlayer.getCurrentIndex()
        // );
        if (duration) {
          clearInterval(this.timer);
          this.setAudioLoading(false);
          this.isPlay = true;
          // 表示时长加载完成====

          this.progress = 0;
          this.setAudioCurrentTime(0);
          this.xPlayer.seek(this.audioCurrentTime);
          this.setAudioCurrentIndex(this.xPlayer.getCurrentIndex());
          this.setDuration(this.xPlayer.getDuration());
          this.handleDetail();
        }
      }, 100);
    },
    handleDetail() {
      if (this.questionTips === "音频详情") {
        let audioTemplate = ximalayaDetailTemplate(
          this.audioList,
          this.audioList[this.audioCurrentIndex].track_title
        );
        this.contactDisData([{ content: { right: true, tips: "音频详情" } }]);
        this.contactDisData(audioTemplate);
      }
    },
    debounce(fn, wait) {
      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(fn, wait);
    },
  },
};
</script>

<style scoped lang="less">
.view22Wrapper {
  width: 8.72rem;
  height: 6.03rem;
  padding: 0.67rem 0.59rem;
  box-sizing: border-box;
  background-color: white;
  position: relative;
  .loading {
    position: absolute;
    width: 8.72rem;
    height: 6.03rem;
    background-color: #fff;
    z-index: 10;
    left: 0rem;
    top: 0;
    border-radius: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: auto;
      height: 2rem;
    }
  }
  .playerWrapper {
    .audioInfo {
      padding-left: 0.08rem;
      display: flex;
      justify-content: flex-start;
      .cover {
        width: 1.65rem;
        height: 1.65rem;
        border-radius: 0.13rem;
      }
      .content {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;
        margin: 0 0.27rem;
        .name {
          font-size: 0.43rem;
          font-weight: 600;
          line-height: 0.43rem;
          font-family: PingFangSC-Medium, PingFang SC;
          margin-bottom: 0.16rem;
        }
        .source {
          font-size: 0.32rem;
          font-weight: 400;
          color: #999999;
          line-height: 0.32rem;
          margin-bottom: 0.43rem;
        }
      }
    }
    .slider {
      width: 7.55rem;
      position: relative;
      height: 0.1rem;
      display: flex;
      padding: 0.45rem 0 0.19rem 0;
      align-items: center;
      cursor: default;
      border-radius: 0.3rem;
      user-select: none;
      outline: none;
      .slider-track {
        position: absolute;
        height: 0.05rem;
        left: 0;
        right: 0;
        border-radius: 0.3rem;
        top: 0.45rem;
        background-color: #dfe8fd;
      }

      .slider-fill {
        position: absolute;
        height: 0.1rem;
        width: 100%;
        background-color: #376df6;
        left: 0;
        border-radius: 0.3rem;
        top: 0.45rem;
        margin-top: -1px;
      }

      .slider-thumb {
        position: absolute;
        width: 0.21rem;
        top: 0.48rem;
        height: 0.21rem;
        background-color: #376df6;
        color: #ffbb38;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
    .timeInfo {
      display: flex;
      justify-content: space-between;
      height: 0.32rem;
      font-size: 0.32rem;
      font-weight: 400;
      color: #666666;
      line-height: 0.32rem;
    }
    .menu {
      margin: 0.58rem 0 0.72rem 0;
      height: 1rem;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .last,
      .next {
        width: 0.43rem;
        height: 0.43rem;
        display: flex;
        justify-content: center;
      }
      .play {
        width: 1.01rem;
        height: 1.01rem;
      }
    }
  }
}
</style>
